export default __webpack_public_path__ + "static/banner-save-money-with-your-credit-card-01845f236fab46d9ed43681c914bfb62.jpg";